<template>
  <div>
    <div class="text-center pa-3">
      <v-btn
        icon
        @click="showTabs = !showTabs"
      >
        <v-img
          :src="showTabs ? 'https://i.ibb.co/D98wmk7/up.png' : 'https://i.ibb.co/D5gDFPk/down.png'"
          contain
          class="pb-3"
          height="35"
        />
      </v-btn>
    </div>

    <v-expand-transition>
      <v-tabs
        v-if="showTabs"
        v-model="filter"
        background-color="transparent"
        centered
        hide-slider
      >
        <v-tab
          v-for="(tab, i) in categories"
          :key="i"
          :href="`#${tab}`"
        >
          {{ tab }}
        </v-tab>
      </v-tabs>
    </v-expand-transition>
  </div>
</template>

<script>
  // Utilities
  import { sync } from 'vuex-pathify'

  export default {
    name: 'VFilter',

    data: () => ({
      showTabs: true,
    }),

    computed: {
      ...sync('photographs', [
        'categories',
        'filter',
      ]),
    },
  }
</script>
